import { useEffect } from 'react';
import oidcAuth from '../../services/auth/oidc-client';

const SilentRenew = () => {
  useEffect(() => {
    oidcAuth.handleSilentCallback();
  }, []);

  return null;
};

export default SilentRenew;

